// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Essayez à nouveau en utilisant une date complète telle que : ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Groupe',
  chart_labelSeries: () => 'Série',
  chart_labelValue: () => 'Valeur',
  checkboxSet_requiredMessageDetail: () => 'Obligatoire',
  checkbox_requiredMessageDetail: () => 'Obligatoire',
  close: () => 'Fermer',
  collection_noData: () => 'Aucune donnée à afficher.',
  collection_selectAllRows: () => 'Sélectionner toutes les rangées',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Sélectionner la rangée ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Ne peut pas être trié',
  collection_sortEnabled: () => 'Peut être trié',
  confirmation: () => 'Confirmation',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' de ' + p['totalCount'],
  dataVisualization_noData: () => 'Aucune donnée à afficher',
  dataVisualization_stateSelected: () => 'Sélectionné',
  dataVisualization_stateUnselected: () => 'Non sélectionné',
  error: () => 'Erreur',
  expandableList_expandCollapseInstructionText: () =>
    "Utilisez les touches fléchées pour réduire ou étendre l'affichage",
  expandableList_groupCollapse: () => 'Réduit',
  expandableList_groupExpand: () => 'Étendu',
  filePicker_addFiles: () => 'Ajouter des fichiers',
  filePicker_dropzonePrimaryText: () => 'Glisser-déposer',
  filePicker_dropzoneSecondaryText: () => 'Sélectionner un fichier ou déposer un fichier ici',
  filePicker_dropzoneSecondaryTextMultiple: () =>
    'Sélectionner des fichiers ou déposer des fichiers ici',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Vous ne pouvez pas charger des fichiers ayant les types suivants : ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Charger un fichier à la fois',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Vous ne pouvez pas charger des fichier de type ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'inconnu',
  formControl_clear: () => 'Effacer',
  formControl_day: () => 'Jour',
  formControl_helpAvailable: () => 'Aide disponible',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Vous avez atteint la limite de ' +
    ((
      {
        one: '1 caractère',
        many: new Intl.NumberFormat('fr-CA').format(p['CHARACTER_LIMIT']) + ' caractères'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('fr-CA').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('fr-CA').format(p['CHARACTER_LIMIT']) + ' caractères') +
    '.',
  formControl_loading: () => 'Chargement',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Longueur maximale ' + p['MAX_LENGTH'] + ' dépassée.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' caractères restants.',
  formControl_month: () => 'Mois',
  formControl_readOnly: () => 'Lecture seule',
  formControl_requiredMessageDetail: () => 'Entrez une valeur.',
  formControl_year: () => 'Année',
  gantt_labelDate: () => 'Date',
  gantt_labelEnd: () => 'Fin',
  gantt_labelLabel: () => 'Étiquette',
  gantt_labelRow: () => 'Rangée',
  gantt_labelStart: () => 'Début',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Aucune section correspondante trouvée.',
  indexer_keyboardInstructionText: () => 'Appuyez sur Entrée pour sélectionner la valeur.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Entre ' + p['FROM_SECTION'] + ' et ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Touchez deux fois et maintenez pour passer en mode geste, puis glissez vers le haut ou le bas pour ajuster la valeur.',
  info: () => 'Infos',
  inputDateMask_date_cleared: () => 'Date effacée',
  inputDateMask_dayPlaceholder: () => 'jj',
  inputDateMask_empty_segment: () => 'Vide',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'aaaa',
  inputNumber_converterParseError: () => 'Entrez un nombre.',
  inputNumber_decrease: () => 'Réduire',
  inputNumber_increase: () => 'Augmenter',
  inputPassword_hidden: () => 'Mot de passe masqué',
  inputPassword_hide: () => 'Masquer le mot de passe',
  inputPassword_show: () => 'Afficher le mot passe',
  list_suggestion: () => 'Suggestion',
  messageToast_allMessagesClosed: () => 'Tous les avis Toast sont fermés.',
  message_close: () => 'Fermer',
  message_confirmation: () => 'Réussite',
  message_error: () => 'Erreur',
  message_info: () => 'Infos',
  message_navigationFromMessagesRegion: () =>
    'Entrée dans la région des messages. Appuyez sur F6 pour retourner au dernier élément ciblé.',
  message_navigationToMessagesRegion: () =>
    'La région des messages contient des nouveaux messages. Appuyez sur F6 pour accéder à la région du message le plus récent.',
  message_warning: () => 'Avertissement',
  noData_message: () => 'Aucun élément à afficher',
  overflowItemLabel: () => 'Onglets supplémentaires',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'En cours',
  radio_helpForRadio: () => 'Aide pour le bouton radio',
  radio_requiredMessageDetail: () => 'Sélectionner une valeur.',
  selectMultiple_apply: () => 'Appliquer',
  selectMultiple_back: () => 'Précédent',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Appuyez sur la touche de retour arrière ou sur la touche de suppression pour supprimer la valeur sélectionnée.',
  selectMultiple_selectedValues: () => 'Valeurs sélectionnées',
  selectMultiple_showSelectedValues: () => 'Afficher les valeurs sélectionnées uniquement.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valeurs sélectionnées.',
  select_addToList: () => 'Ajouter à la liste',
  select_addToListAvailable: () => 'Ajouter à la liste disponible',
  select_moreSearchOptions: () => 'Autres options de recherche',
  select_moreSearchOptionsAvailable: () => 'Autres options de recherche disponibles',
  select_noMatchesFound: () => "Aucune correspondance n'a été trouvée.",
  select_oneMatchFound: () => 'Une correspondance a été trouvée',
  select_requiredMessageDetail: () => 'Sélectionner une valeur.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' correspondances trouvées',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' correspondances ou plus trouvées',
  selector_selected: () => 'Case cochée',
  selector_unselected: () => 'Case non cochée',
  tabBarNavigationList_removeCueText: () => 'Supprimable',
  timeComponent_tooltipZoomIn: () => 'Zoom avant',
  timeComponent_tooltipZoomOut: () => 'Zoom arrière',
  train_current: () => 'Courante',
  train_message_type: () => 'Type de message',
  train_not_visited: () => 'Non visitée',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Étape ' + p['currentStep'] + ' de ' + p['numberOfSteps'],
  train_visited: () => 'Visitée',
  userAssistance_learnMore: () => 'En savoir plus',
  userAssistance_required: () => 'Obligatoire',
  viz_drillable: () => 'Forage possible',
  warn: () => 'Avertissement'
};
export default bundle;
